"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@8base/utils");
/**
 * Creates instacne of the api token auth client
 */
class ApiTokenAuthClient {
    constructor(options, storage = window.localStorage, storageKey = 'auth') {
        utils_1.throwIfMissingRequiredParameters(['apiToken'], utils_1.PACKAGES.API_TOKEN_AUTH_CLIENT, options);
        const { apiToken } = options;
        this.storageAPI = new utils_1.StorageAPI(storage, storageKey);
        this.apiToken = apiToken;
        this.storageAPI.setState({ token: apiToken });
    }
    getState() {
        return Object.assign({}, this.storageAPI.getState(), { token: this.apiToken });
    }
    setState(state) {
        this.storageAPI.setState(Object.assign({}, state, { token: this.apiToken }));
    }
    purgeState() {
        this.storageAPI.purgeState();
        this.storageAPI.setState({ token: this.apiToken });
    }
    checkIsAuthorized() {
        return true;
    }
}
exports.ApiTokenAuthClient = ApiTokenAuthClient;
//# sourceMappingURL=ApiTokenAuthClient.js.map